/**
 * @name flowHistoryFieldValue
 * @module flowingly.runner.directives
 * @description display field values consistently for completed steps
 * ### Notes
 * 
 * @usage
 * ```
    <flow-history-field-value field-value="{{item.Text}}"></flow-history-field-value>
 * ```
 */
import angular from 'angular';
import FlowHistoryFieldValueBridge from './FlowHistoryFieldValueBridge';

angular
  .module('flowingly.runner.directives')
  .component('flowHistoryFieldValue', FlowHistoryFieldValueBridge);
